import * as React from 'react';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/CloseSharp';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from "@mui/material/Button";
import MenuItem  from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormHelperText from "@mui/material/FormHelperText";
import {setWorkspaceData,saveNetZeroPathwayData} from "../features/workspaceDataSlice";

export default function NetzeroPopup(props) {
   const {title,popupData,openPopup, setClosePopup,loadData} = props;
   const {newAssessmentData} = useSelector(state => state.newAssessment);
   const {
    workspaceData,
    savedWorkspaceData,
    materials,
    region,
    changedMaterial,
    scenario,
    netZeroPathwayData
  } = useSelector((state) => state.workspaceData);
  const dispatch = useDispatch();
  
  const [netzeroData, setNetZeroData] = useState({
    scenario: scenario,

    carbon_neutral_selection: popupData.carbonNeutral?1:0,

    design_efficiency_selection: popupData.designEfficiency?1:0,

    remaining_carbon_emission: popupData.remainingCarbonEmission !== ""? popupData.remainingCarbonEmission:0,

    climate_active_certified_product: popupData.climateActiveCertifiedProduct !== ""? popupData.climateActiveCertifiedProduct:0,

    material_quantity_reduction: popupData.materialQuantityReduction !== ""? popupData.materialQuantityReduction:0
    ,

    material: changedMaterial

  });

  
   
  const [quantitySaveClicked, setQuantitySaveClicked] = useState(false);
  useEffect(() => {
    setNetZeroData((prevState) => ({
      ...prevState,
      scenario:scenario,
      material:changedMaterial,
      
    carbon_neutral_selection:  popupData.carbonNeutral?1:0,

    design_efficiency_selection: popupData.designEfficiency?1:0,

    remaining_carbon_emission: netzeroData.remaining_carbon_emission,

    climate_active_certified_product:netzeroData.climate_active_certified_product,

    material_quantity_reduction: netzeroData.material_quantity_reduction
    

    }));
   }, [savedWorkspaceData,popupData]);

   useEffect(() => {
    setNetZeroData((prevState) => ({
      ...prevState,
      scenario:scenario,
      material:changedMaterial,
      
      carbon_neutral_selection: popupData.carbonNeutral?1:0,

      design_efficiency_selection: popupData.designEfficiency?1:0,
  
      remaining_carbon_emission: popupData.remainingCarbonEmission !== ""? popupData.remainingCarbonEmission:0,
  
      climate_active_certified_product: popupData.climateActiveCertifiedProduct !== ""? popupData.climateActiveCertifiedProduct:0,
  
      material_quantity_reduction: popupData.materialQuantityReduction !== ""? popupData.materialQuantityReduction:0
      ,
    

    }));
   }, [scenario,changedMaterial]);

   useEffect(() => {
    if (quantitySaveClicked) {
      loadData();
      setQuantitySaveClicked(false);
    }
    },[quantitySaveClicked]);

  

  
  const changeQuantity = (event) => {
    let inputValue = event.target.value;
  inputValue = inputValue.replace(/[^0-9]/g, "");
  let numericValue = parseInt(inputValue);
  if (isNaN(numericValue) || numericValue < 0){
    numericValue = 0;
  }

  if (numericValue > 30) {
    event.target.value = netzeroData.material_quantity_reduction;
    return;
  }
    setNetZeroData((prevState) => ({
      ...prevState,
      material_quantity_reduction:numericValue
    }));
  }
  

  const changeClimateActVal = (event) => {
    let inputValue = event.target.value;
  inputValue = inputValue.replace(/[^0-9]/g, "");
  let numericValue = parseInt(inputValue);
  if (isNaN(numericValue) || numericValue < 0){
    numericValue = 0;
  }

  if (numericValue > 100) {
    event.target.value = netzeroData.climate_active_certified_product;
    return;
  }
    setNetZeroData((prevState) => ({
      ...prevState,
      climate_active_certified_product:numericValue
    }));
    
   
    let totMaterialEmission = 0,i;
    const filteredData = savedWorkspaceData.filter((obj) => {
       if(obj.scenario === scenario && obj.material === changedMaterial)
       return obj;
      
    });
     for(i=0;i<filteredData.length;i++){
      if(filteredData[i].building_sub_elements && filteredData[i].building_sub_elements !== "")
      {
  
        let emissionIntensity = "";
        if(!filteredData[i].emission_intensity){
          emissionIntensity = 0;
        }
        else if (typeof filteredData[i].emission_intensity === "string"){
            emissionIntensity = filteredData[i].emission_intensity.split(' ');
            emissionIntensity = emissionIntensity[0];
        }
        else
        {
          emissionIntensity = filteredData[i].emission_intensity
        }
        
            emissionIntensity = filteredData[i].quantity * emissionIntensity;
            totMaterialEmission = totMaterialEmission + emissionIntensity;
      }
    }
      let climateActValPercent  = numericValue/100;
      climateActValPercent = 1 - climateActValPercent;
      let buildingArea = 0;

      if(newAssessmentData.buildingArea !== undefined){
        buildingArea =  newAssessmentData.buildingArea;
      }     
      else if(workspaceData.workspace_data.project_attributes.building_area !== undefined){
        buildingArea =  workspaceData.workspace_data.project_attributes.building_area;   
      }
      let remainCarbonEmissionVal = totMaterialEmission * climateActValPercent;
     // remainCarbonEmissionVal = remainCarbonEmissionVal/buildingArea;
    
setNetZeroData((prevState) => ({
  ...prevState,
  remaining_carbon_emission: remainCarbonEmissionVal.toFixed(2)
}));
  
  };

  const saveDetails = () => {
    if (popupData.type === "designEffcy") {
      const modifiedData = savedWorkspaceData.map((obj) => {
        let qnty = "";
        if(obj.scenario === scenario && obj.material === changedMaterial){
        qnty = netzeroData.material_quantity_reduction / 100;
        qnty = 1 - qnty;
        return { ...obj, quantity: (obj.quantity * qnty).toFixed(2) };
        }
        return obj;
      });
      setNetZeroData((prevState) => ({
        ...prevState,
        design_efficiency_selection:1
      }));
      dispatch(setWorkspaceData(modifiedData));
      
      setQuantitySaveClicked(true);
      //loadData();
    }else{
    
         
    setNetZeroData((prevState) => ({
      ...prevState,
      carbon_neutral_selection:1
    }));
    }
  
   let existFlag = 0;
    const updatedNetZeroPathwayObj = netZeroPathwayData.map((obj) => {
      if (obj.scenario === scenario && obj.material === changedMaterial) {
        existFlag = 1;
        return netzeroData;
      }
      return obj;
    });
    if(existFlag == 0)
    updatedNetZeroPathwayObj.push(netzeroData);
    dispatch(saveNetZeroPathwayData(updatedNetZeroPathwayObj));

    setClosePopup("save")
  }

  return (
    <div>
      <Dialog className="custom-popup"  open={openPopup}>
        <DialogTitle className='custom-header'><span className="title">{title} 
        {changedMaterial && <div>-{changedMaterial}</div>}</span>  
        <IconButton onClick={setClosePopup} aria-label="Close">
        <DeleteIcon />
      </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <Box component="form" className="custom-form">
          {popupData.type === "designEffcy" && (
            <Box className="form-field">
              <label>% Material Quantity Reduction</label>
              <TextField  onChange={changeQuantity} value={netzeroData.material_quantity_reduction} fullWidth type="text" />
  
            <FormHelperText>
               Enter range between 0 - 30%
              </FormHelperText>
            </Box>
          )}
          {popupData.type === "carbonRdcn" && (
            <Box>
              <Box className="form-field">
                <label>% Of Climate Active Certified Product</label>
             <TextField
              fullWidth
              value={netzeroData.climate_active_certified_product}
              onChange={changeClimateActVal}/>
            <FormHelperText>
               Enter range between 0 - 100%
              </FormHelperText>
              </Box>
              <Box className="form-field">
                <label>Remaining Carbon Emission (kgCO2-eq)</label>
                <TextField value={netzeroData.remaining_carbon_emission} disabled fullWidth type="text" />
              </Box>
            </Box>
          )}
          <Box className="custom-footer">
            <Button
              variant="outlined"
              className="btn-danger"
              onClick={setClosePopup}
            >
              Cancel
            </Button>
            <Button
              className="btn-secondary"
              variant="contained"
              onClick={saveDetails}
            >
              Save
            </Button>
          </Box>
        </Box>
          </DialogContentText>
         
        </DialogContent>
      </Dialog>
    </div>
  );
}
